// extracted by mini-css-extract-plugin
module.exports = {"amex":"HK","visa":"IK","discover":"JK","mastercard":"KK"};